import { translation, } from '@tymia/main-api';
import { useConfig, } from './common/config/ConfigProvider.js';
export function useTranslation() {
    const config = useConfig();
    return translation(config.locale);
}
//# sourceMappingURL=useTranslation.js.map